import api from './index';
let exports = {};

exports.getRetailerBizAreaList = function (data, callback) {
    api.post('/merchtComn/retailer/biz/area/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getRetailerBizAreaListForSelect = function (data, callback) {
    api.post('/merchtComn/retailer/biz/area/list/get/for/select')
    .data(data)
    .done(callback)
    .go();
};

exports.getRetailerBizArea = function (params, callback) {
    api.get('/merchtComn/retailer/biz/area/get')
    .params(params)
    .done(callback)
    .go();
};
// 根据编码获取经营区域
exports.getRetailerBizAreaByCode = function (params, callback) {
    api.get('/merchtComn/retailer/biz/area/get/by/code')
    .params(params)
    .done(callback)
    .go();
};

exports.doValidateRetailerBizAreaCanDisabled = function (params, callback) {
    api.get('/merchtComn/retailer/biz/area/validate/do')
    .params(params)
    .done(callback)
    .go();
};

exports.saveRetailerBizArea = function (data, callback) {
    api.post('/merchtComn/retailer/biz/area/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doRetailerBizAreaDisabled = function (data, callback) {
    api.post('/merchtComn/retailer/biz/area/disabled/do')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteRetailerBizArea = function (data, callback) {
    api.post('/merchtComn/retailer/biz/area/delete/do')
    .data(data)
    .done(callback)
    .go();
};

//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/bizArea.js
// module id = 158
// module chunks = 0